import axios from "axios";
import store from "@/store";
import alerts from "@/alerts/alert";

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      Authorization: `Bearer ${store.getters["auth/token"]}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
